import { configureStore } from '@reduxjs/toolkit';
import ideasReducer from './slices/ideasSlice';
import filtersReducer from './slices/filtersSlice';
import loadingReducer from './slices/loadingSlice';

export const store = configureStore({
    reducer: {
        ideas: ideasReducer,
        filters: filtersReducer,
        loading: loadingReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 